import { IoTicket } from "react-icons/io5";
import { EventFragment } from "../../__generated__/graphql";
import EventFilling from "../EventFilling";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import useOrganizationHasIntegrations from "../../hooks/useOrganizationHasIntegrations";
import Button from "../Button";
import { LuRefreshCcw } from "react-icons/lu";
import { useState } from "react";
import PimsImportModal from "../../pages/projects/components/PimsImportModal";

export default function EventTickets({ event }: { event: EventFragment }) {
  const { hasPimsIntegration } = useOrganizationHasIntegrations();
  const [isSelectingPimsEventModal, setIsSelectingPimsEventModal] =
    useState(false);

  const eventFilling = () => {
    const totalSoldTickets = event.eventTickets?.length
      ? event.eventTickets[event.eventTickets.length - 1]?.soldTickets
      : 0;

    if (!totalSoldTickets)
      return (
        <div className="h-30 text-center text-tertiary text-sm flex items-center justify-center">
          Pas de données sur la billetterie
        </div>
      );

    if (!event.maxCapacity && !event.costingCapacity) {
      return (
        <div className="flex flex-col mt-4 justify-center items-center">
          <div className="text-xl font-medium text-primary">
            {totalSoldTickets} places vendues
          </div>
          <div className="text-xs text-accent flex items-center gap-1">
            <InformationCircleIcon className="w-4 h-4" />
            Pas d'informations sur la capacité maximale
          </div>
        </div>
      );
    }

    return (
      <div className="mt-2">
        <EventFilling
          totalSoldTickets={totalSoldTickets}
          maxCapacity={event.maxCapacity ?? 0}
          costingCapacity={event.costingCapacity ?? 0}
          numberOfGauges={40}
          eventTicketsSyncedAt={event.eventTicketsSyncedAt}
        />
      </div>
    );
  };

  const syncWithPims = () => {
    if (event.eventTickets?.length && event.eventTickets.length > 0) {
      return;
    }

    if (!hasPimsIntegration) {
      return;
    }

    return (
      <Button
        variant="secondary"
        className="text-sm"
        onClick={() => setIsSelectingPimsEventModal(true)}
      >
        <LuRefreshCcw className="w-4 h-4 mr-2" />
        Synchroniser avec Pims
      </Button>
    );
  };

  return (
    <>
      <PimsImportModal
        isOpen={isSelectingPimsEventModal}
        onClose={() => setIsSelectingPimsEventModal(false)}
        mode="eventTickets"
        eventId={event.id}
      />

      <div className="w-full rounded-md p-4 border border-input h-full">
        <div className="flex justify-between items-center">
          <div className="flex flex-col flex-1">
            <div className="flex justify-between items-center">
              <div className="text-lg font-bold text-primary flex items-center gap-2">
                <IoTicket />
                Billetterie
              </div>
              {/* <Button variant="secondary" className="text-sm">
              + Ajouter des invitations
              </Button> */}
            </div>

            {syncWithPims()}
          </div>
        </div>

        {eventFilling()}
      </div>
    </>
  );
}
